import { useState, useEffect } from 'react';

interface Breakpoint {
  isMobile: boolean;   // < 640px
  isTablet: boolean;   // 640px – 1023px
  isDesktop: boolean;  // >= 1024px
  isMobileOrTablet: boolean; // < 1024px
}

export const useBreakpoint = (): Breakpoint => {
  const getBreakpoint = (): Breakpoint => {
    const w = window.innerWidth;
    return {
      isMobile: w < 640,
      isTablet: w >= 640 && w < 1024,
      isDesktop: w >= 1024,
      isMobileOrTablet: w < 1024,
    };
  };

  const [bp, setBp] = useState<Breakpoint>(getBreakpoint);

  useEffect(() => {
    const handler = () => setBp(getBreakpoint());
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return bp;
};
